import React, { FC, PropsWithChildren } from "react";
import classnames from "classnames";

import "./index.scss";

export type ChartProps = PropsWithChildren<{ className?: string }>;

export type ChartComponents = {
  Title: FC<PropsWithChildren>;
  Subtitle: FC<PropsWithChildren>;
  Content: FC<PropsWithChildren>;
  Legend: FC<PropsWithChildren>;
  LegendItem: FC<PropsWithChildren>;
};

const Title: FC<ChartProps> = ({ children, className }) => {
  return <div className={classnames("chart-title", className)}>{children}</div>;
};

const Legend: FC<ChartProps> = ({ children, className }) => {
  return <div className={classnames("chart-legend", className)}>{children}</div>;
};

const LegendItem: FC<ChartProps> = ({ children, className }) => {
  return <span className={classnames("chart-legend-item", className)}>{children}</span>;
};

const Subtitle: FC<ChartProps> = ({ children, className }) => {
  return <div className={classnames("chart-subtitle", className)}>{children}</div>;
};

const Content: FC<ChartProps> = ({ children, className }) => {
  return <div className={classnames("chart-content", className)}>{children}</div>;
};

export const Chart: FC<ChartProps> & ChartComponents = ({ children, className }) => {
  return <div className={classnames("chart-component", className)}>{children}</div>;
};

Chart.Title = Title;
Chart.Subtitle = Subtitle;
Chart.Content = Content;
Chart.Legend = Legend;
Chart.LegendItem = LegendItem;
